// eslint-disable-next-line jira/filename-case
import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const OpenHelpPanelLinkThroughEventListener = lazy(
	() =>
		import(
			/* webpackChunkName: "async-open-help-panel-link-through-event-listener" */ './services/open-help-panel-link-through-event-listener/OpenHelpPanelLinkThroughEventListener.tsx'
		),
	{ ssr: false },
);

export const AsyncOpenHelpPanelLinkThroughEventListener = (): React.JSX.Element => (
	<JSErrorBoundary
		id="open-help-panel-link-through-event-listener"
		packageName="jira-help-panel-button"
	>
		<Placeholder name="async-open-help-panel-link-through-event-listener" fallback={null}>
			<OpenHelpPanelLinkThroughEventListener />
		</Placeholder>
	</JSErrorBoundary>
);

export default AsyncOpenHelpPanelLinkThroughEventListener;
